import { Breadcrumb, Button, Card, Form, Input, Modal, Select } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/quicktbreadrans.svg";
import AccountCard from "../../components/account-card";
import { useTranslation } from "react-i18next";
import SendMoneyService from "../../services/send-money.service";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import CommonOtp from "../../components/otp";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import {
  accountListSelector,
  modeSelector,
  selectedAccountSelector,
} from "../../store/selectors/app.selector";
import { useDispatch, useSelector } from "react-redux";
import TransferService from "../../services/transfer.service";
import {
  setAccountList,
  setSelectedAccount,
} from "../../store/actions/app.action";
import {
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  amountFormat,
  handlePasteNotAllowSpace,
} from "../../services/common.service";
import { CONFIG } from "../../environment";
import AccountService from "../../services/accounts.service";
import AccountDisplay from "../../components/account-display";
import { NumericFormat } from "react-number-format";
import dayjs from "dayjs";
import AccountDisplayView from "../../components/account-display-view";
import AccountSelectedCard from "../../components/account-selected-card";
import PendingAuthService from "../../services/approvals.service";

export default function SendToPhone() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [stage, setStage] = useState(1);
  const [cancelVisible, setCancelVisible] = useState(false);
  const [verifyDetails, setVerifyDetails] = useState({});
  const [form] = Form.useForm();
  const accountList = useSelector(accountListSelector);
  const [formDetails, setFormDetails] = useState({});
  const [respDetails, setRespDetails] = useState({});
  const dispatch = useDispatch();
  const selectedAccount = useSelector(selectedAccountSelector);
  const [accountDetails, setAccountDetails] = useState({});
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [fspCodesList, setFspCodesList] = useState([]);
  const [selectedFspBank, setSelectedFspBank] = useState({});
  const mode = useSelector(modeSelector);
  const [chargesList, setChargesList] = useState([]);

  useEffect(() => {
    getFspCodes();
  }, []);

  const getFspCodes = useCallback(async () => {
    try {
      const response = await TransferService.getFspCodes();
      if (response.status === 200) {
        setFspCodesList(
          response.data["fspDetails"].filter((ele) => ele.fspType === "BANK")
        );
      }
    } catch (error) {}
  }, []);
  const onVerify = useCallback(
    async (values) => {
      try {
        const srcAccDetails = accountList.find(
          (ele) => ele.accountNo === selectedAccount.accountNo
        );

        const transferAmount =
          typeof values.amount === "number"
            ? values.amount
            : parseFloat(values.amount.replaceAll(/,/g, ""));
        const reqParams = {
          srcAcct: srcAccDetails?.accountNo,
          accountName: srcAccDetails?.accountName,
          srcAccName: srcAccDetails?.accountName,
          srcBr: srcAccDetails?.branchId,
          srcCcy: srcAccDetails?.accountCurrency,
          destBr: accountDetails?.accBranch || "",
          destCcy: accountDetails?.accCcy || CONFIG?.CURRENCY,
          destAcct: values?.destAcctNo,
          amount: transferAmount,
          narration: values?.remarks || "",
          remarks: values?.remarks || "",
          remarksTag: values?.remarks,
          txnType: "PESALINK",
          destBankName: selectedFspBank?.bankName,
          destBankAddr: "",
          destBankCty: "",
          bankName: selectedFspBank?.fspName,
          beneBrn: selectedFspBank?.sortCode,
          txnCcy: srcAccDetails?.accountCurrency,
          txnDate: dayjs(new Date()),
          chargeBornesBy: "OUR",
          beneName: accountDetails?.customerName,
          beneMobileNo: "",
          beneMail: "",
          beneAddr: "",
          fxDealRefNo: values?.fxDealRefNo || "",
          bicCode: selectedFspBank.sortCode,
          sortCode: "",
          swiftCode: "",
          custId: srcAccDetails?.customerId,
          bulkTransfer: false,
          paymentType: "ONCE",
          numberOfInstallments: "",
          payeeId: 0,
          scheduled: false,
          addBene: "",
          recurring: "",
          scheduledDate: "",
          frequency: values?.frequency || "",
          destIfscCode: "STP",
          customFields: {
            mobile: values?.destAcctNo,
          },
        };
        setFormDetails(reqParams);
        getCharges(reqParams);
      } catch (error) {
        console.log(error);
      }
    },
    [accountList, accountDetails, selectedAccount, selectedFspBank]
  );
  const getCharges = useCallback(
    async (data) => {
      try {
        const req = {
          module: "FUNDTRANSFER",
          srcAcct: data.srcAcct,
          srcCcy: data.srcCcy,
          destCcy: data.destCcy,
          destAcct: data.destAcct,
          destBankName: data.destBankName,
          amount: data.amount,
          txnType: data.txnType,
          chargeBornesBy: data.txnType === "SWIFT" ? "OUR" : "",
        };
        const response = await AccountService.getAllCharges(req);
        if (response.status === 200) {
          setChargesList(response.data);
          console.log(response.data);
          setStage(2);
        }
      } catch (error) {}
    },
    [formDetails]
  );

  const fundTransferVerify = useCallback(async () => {
    try {
      const req = {
        ...formDetails,
      };
      setFormDetails(req);
      const response = await TransferService.fundTransferVerify(req);
      if (response.status === 200) {
        setVerifyDetails(response.data["data"]);
        if (response.data["data"]["otpEnabled"]) {
          setStage(3);
        } else {
          fundTransferConfirm({
            ...req,
            ...{ otp: CONFIG.DEFAULT_OTP },
          });
        }
      }
    } catch (error) {}
  }, [formDetails]);

  const fundTransferConfirm = useCallback(async (reqParams) => {
    try {
      setFormDetails(reqParams);
      const response = await TransferService.fundTransferConfirm(reqParams);
      if (response.status === 200) {
        dispatch(setAccountList([]));
        setRespDetails({
          message: response.data?.message,
          ...response.data["data"],
        });
        await fetchAccounts();
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
      if (["TG-USR-40025", "TG-USR-40026"].indexOf(error.data.code) < 0) {
        setStage(1);
      }
    }
  }, []);

  const fetchAccounts = useCallback(async () => {
    try {
      const response = await AccountService.getQuickAccounts("BA");
      if (response.status === 200) {
        const selectedAccountDetails =
          response?.data["data"]["accounts"].find(
            (ele) => ele.primaryAccount === true
          ) ||
          response.data["data"]["accounts"][0] ||
          [];
        dispatch(setSelectedAccount(selectedAccountDetails));
      }
    } catch (error) {}
  }, []);

  const accountLookUp = useCallback(
    async (acctNo) => {
      try {
        if (+acctNo.length >= CONFIG?.MOBILE_NO_LENGTH) {
          const reqParams = {
            transferType: "PESALINK",
            mobileNo: acctNo,
          };
          const response = await SendMoneyService.accountLookUp(reqParams);
          if (response.status === 200) {
            setAccountDetails(response.data);
            // setFspCodesList(response.data["listOfBanks"]);
          }
        }
      } catch (error) {
        setAccountDetails({});
      }
    },
    [selectedAccount, CONFIG, selectedFspBank]
  );

  const onfspBankChange = (value) => {
    setSelectedFspBank(fspCodesList.find((e) => e.fspCode === value));
  };

  const handleDownload = useCallback(
    async (selected) => {
      try {
        const reqParams = {
          txnId: selected?.txnId,
          txnType: formDetails?.txnType,
        };
        setSuccessVisible(false);
        await PendingAuthService.downloadReceipts(reqParams);
        navigate("/pesaLink");
      } catch (err) {}
    },
    [formDetails]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) =>
              fundTransferConfirm({ ...formDetails, ...values })
            }
            handleResendOtp={() => fundTransferVerify()}
            cancelTransaction={() => {
              navigate("/transfer");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p>
            {t("pages.fundtransfer.transfer_desc", {
              defaultValue: "Please enter below details",
            })}
          </p>
          <div className="row">
            <div className="d-flex align-items-center">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <AccountDisplay type="image" currencyFilter={true} />
              </div>
            </div>
          </div>
          <Form
            layout="vertical"
            requiredMark={true}
            form={form}
            onFinish={onVerify}
            initialValues={formDetails}
          >
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  label={t("common.mobile_number", {
                    defaultValue: "Mobile Number",
                  })}
                  name="destAcctNo"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.mobile_no_requir", {
                        defaultValue: "Mobile Number is required",
                      }),
                    },
                    {
                      min: CONFIG?.MOBILE_NO_LENGTH,
                      max: CONFIG?.MOBILE_NO_LENGTH,
                      message: t("errorMesssages.mobile_no_valid", {
                        defaultValue: "Please enter valid Mobile Number",
                      }),
                    },
                  ]}
                >
                  <Input
                    maxLength={CONFIG?.MOBILE_NO_LENGTH}
                    onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                    onPaste={(e) => handlePasteNotAllowSpace(e)}
                    placeholder={t("common.mobile_number", {
                      defaultValue: "Mobile Number",
                    })}
                    onBlur={(e) => {
                      accountLookUp(e.target.value);
                    }}
                    size="large"
                    addonBefore={CONFIG?.DEFAULT_MOBILE_PREFIX || ""}
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <Form.Item
                  name={"bankName"}
                  label={t("pages.sendMoney.payee.bank_name", {
                    defaultValue: "Bank Name",
                  })}
                  rules={[
                    {
                      required: true,
                      message: t("pages.Add_Bene.bank_name_req", {
                        defaultValue: "Bank Name is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.sendMoney.payee.bank_name", {
                      defaultValue: "Bank Name",
                    })}
                    bordered={true}
                    optionFilterProp="children"
                    showSearch
                    size="large"
                    onChange={(value) => {
                      onfspBankChange(value);
                    }}
                  >
                    {fspCodesList.map((option, idx) => (
                      <Select.Option key={idx} value={option?.fspCode}>
                        {option?.fspName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("common.amount", {
                    defaultValue: "Amount",
                  })}
                  name={"amount"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.amount_required", {
                        defaultValue: "Amount is required",
                      }),
                    },
                    {
                      validator: (_, value) => {
                        if (parseFloat(value) <= 0) {
                          return Promise.reject(
                            t("errorMesssages.amount_valid", {
                              defaultValue: "Amount should be greater than 0",
                            })
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <NumericFormat
                    type="tel"
                    placeholder={t("common.amount", {
                      defaultValue: "Amount",
                    })}
                    maxLength={12}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={false}
                    onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                    size="large"
                  />
                </Form.Item>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  name="remarks"
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.remark_require", {
                        defaultValue: "Reason is required",
                      }),
                    },
                  ]}
                  label={t("common.remarks", {
                    defaultValue: "Reason",
                  })}
                >
                  <Input
                    placeholder={t("common.remarks", {
                      defaultValue: "Reason",
                    })}
                    maxLength={30}
                    size="large"
                    onKeyPress={(e) => allowOnlyAlphaNumericsShouldNotStartWithSpace(e)}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="d-flex justify-content-end ">
              <Button
                onClick={() => navigate("/pesaLink")}
                type="default"
                className="secondary-btn"
                style={{ marginRight: 20 }}
                size="large"
              >
                {t("buttons.cancel_btn", {
                  defaultValue: "Cancel",
                })}
              </Button>

              <Button
                type="primary"
                className="primary-btn"
                htmlType="submit"
                size="large"
              >
                {t("buttons.submit_btn", {
                  defaultValue: "Submit",
                })}
              </Button>
            </div>
          </Form>
        </div>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.sendMoney.payee.payment_txt", {
            defaultValue:
              "Please check the payment details carefully, before you proceed",
          })}
        </p>

        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <AccountDisplayView />
            </div>
          </div>
        </div>

        <div className="confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("common.mobile_number", {
                  defaultValue: "Mobile Number",
                })}
              </label>
              <span>{formDetails?.destAcct}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.Add_Bene.bane_name", {
                  defaultValue: "Beneficiary Name",
                })}
              </label>
              <span>{formDetails?.beneName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.payee.bank_name", {
                  defaultValue: "Bank Name",
                })}
              </label>
              <span>{formDetails?.bankName || "-"}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.transfer_type", {
                  defaultValue: "Transfer Type",
                })}
              </label>
              <span>{formDetails?.txnType}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>{amountFormat(formDetails?.amount)}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.service_request.common_service.charges", {
                  defaultValue: "Charges",
                })}
              </label>
              <span>{amountFormat(chargesList.charges)}</span>
            </div>

            <div className="confirm-label-wrapper">
              <label>
                {t("common.remarks", {
                  defaultValue: "Reason",
                })}
              </label>
              <span>{formDetails?.remarksTag || "-"}</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button
            onClick={() => setStage(1)}
            type="default"
            className="secondary-btn mx-3"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            onClick={() => fundTransferVerify()}
            type="primary"
            className="primary-btn"
            size="large"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </>
    );
  }

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/pesaLink")}>
              {t("navigation.pesaLink", {
                defaultValue: "Pesalink",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.service_request.common_service.send_to_phone", {
                defaultValue: "Send To Phone",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.service_request.common_service.send_to_phone", {
                defaultValue: "Send To Phone",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card"  >
              <AccountCard currencyFilter={true} />
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card"  >
              <AccountSelectedCard />
            </Card>
          </div>
        )}

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="application-card ">{renderSwitch()}</Card>
        </div>
      </div>
      <Modal
        title={t("pages.sendMoney.payee.quick_transfer", {
          defaultValue: "Cancel transfer?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.otp.quitCancelTitle", {
            defaultValue:
              " If you cancel this transaction now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            className="secondary-btn"
            type="default"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/transfer");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{respDetails?.message}</p>
          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/pesaLink");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
            {mode === "AA" && (
              <>
                <Button
                  size="large"
                  onClick={() => {
                    handleDownload(respDetails);
                  }}
                  className="secondary-btn mx-4"
                >
                  {t("buttons.download_btn", { defaultValue: "Download" })}
                </Button>
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}
